/**
 * Build the absolute, shareable checkout deep-link for a bot session.
 *
 *   <origin>/shopping-cart?bot_session_id=<id>
 *
 * Opening it (in a new tab) lands on the same deep-link path WhatsApp replies
 * with: `useBotSessionHydration` reads `bot_session_id`, fetches the assembled
 * ShoppingCartV2 for the session, stashes it, and redirects to /checkout/<uuid>.
 *
 * The web flow is same-session, so the link is tokenless — exactly like the
 * "Complete booking" CTA (`getCheckoutCart(sessionId)` with no token). The
 * signed `token` only exists for cross-channel (WhatsApp) links, where there's
 * no shared session/auth. Built absolute so the chat bubble renders it as a
 * real `target="_blank"` anchor that opens checkout in a new tab.
 */
export function buildBotCheckoutDeepLink(sessionId: string): string {
  const origin =
    typeof window !== 'undefined' && window.location?.origin
      ? window.location.origin
      : '';
  return `${origin}/shopping-cart?bot_session_id=${encodeURIComponent(sessionId)}`;
}
